const PRODUCT_FEED_FORMATS = [
  { label: 'Google Merchant', value: 'GOOGLE_MERCHANT' },
];

export default PRODUCT_FEED_FORMATS;
